import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { cameraOutline, imageOutline, trashOutline } from 'ionicons/icons';

interface PhotoSourceModalProps {
  isOpen: boolean;
  title: string;
  deleteLabel?: string;
  onTakePhoto: () => void;
  onChooseFromGallery: () => void;
  /** Shows the delete option; pass it only when there is a photo to delete. */
  onDelete?: () => void;
  onClose: () => void;
}

/** Bottom list to take a photo, pick one from the gallery or delete the current one. */
export const PhotoSourceModal = ({
  isOpen,
  title,
  deleteLabel = 'Eliminar foto',
  onTakePhoto,
  onChooseFromGallery,
  onDelete,
  onClose,
}: PhotoSourceModalProps) => (
  <IonModal isOpen={isOpen} onDidDismiss={onClose}>
    <IonHeader>
      <IonToolbar>
        <IonTitle className="ml-4">{title}</IonTitle>
        <IonButtons slot="end">
          <IonButton onClick={onClose}>Cerrar</IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent className="ion-padding">
      <IonList>
        <IonItem button onClick={onTakePhoto} data-testid="take-photo-option">
          <IonIcon icon={cameraOutline} slot="start" className="mr-3" />
          <IonLabel>Tomar foto</IonLabel>
        </IonItem>
        <IonItem button onClick={onChooseFromGallery} data-testid="gallery-option">
          <IonIcon icon={imageOutline} slot="start" className="mr-3" />
          <IonLabel>Elegir de la galería</IonLabel>
        </IonItem>
        {onDelete && (
          <IonItem button onClick={onDelete} data-testid="delete-photo-option">
            <IonIcon icon={trashOutline} slot="start" color="danger" className="mr-3" />
            <IonLabel color="danger">{deleteLabel}</IonLabel>
          </IonItem>
        )}
      </IonList>
    </IonContent>
  </IonModal>
);
